import { type LinkComponent, useLocation } from '@tanstack/react-router';
import type { SyntheticEvent } from 'react';
import { Link } from '../../compositions/Link';

export const ListLink: LinkComponent<'a'> = (props) => {
    const prevPath = useLocation({ select: (state) => state.pathname });
    return (
        <Link
            {...(props as any)}
            onClick={(event: SyntheticEvent) => {
                event.stopPropagation();
            }}
            //@ts-ignore
            search={(prevSearch) => ({ prevPath, prevSearch })}
        />
    );
};
